export enum VerificationSteps {
  START_PAGE_TIERS_STEP = "START_PAGE_TIERS_STEP",
  SELFIE_VERIFICATION_STEP = "Photo Verification",
  NIN_VERIFICATION_STEP = "NIN Verification",
  NEXT_OF_KIN_STEP = "Next of Kin Details",
  DOCUMENT_VERIFICATION_STEP = "Document Verification",
  BUSINESS_ADDRESS_STEP = "Business Address",
  REGISTRATION_DETAILS_STEP = "Registration Details",
  BUSINESS_DETAILS_STEP = "Business Details",
  ADDRESS_VERIFICATION_STEP = "Address Verification",
  DIRECTOR_DETAILS_STEP = "Director's Details",
  PROOF_OF_ADDRESS_STEP = "Proof of Address",
  END_PAGE_STEP = "Confirmation",
}
